import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from "vuetify/src/locale/es";

import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

/** Paleta azul de Fidelmira + modo oscuro (customProperties para el CSS del rediseño). */
export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#0e4c88",
        secondary: "#488ebc",
        tertiary: "#747C8D",
        cuartiary: "#F1F0FA",
        surface: "#FFFFFF",
        background: "#F6F8FA",
        success: "#0D9488",
        warning: "#D97706",
        error: "#DC2626",
        info: "#0e4c88",
      },
      dark: {
        primary: "#bfdbfe",
        secondary: "#488ebc",
        tertiary: "#c5d0dc",
        cuartiary: "#243044",
        surface: "#1c2430",
        background: "#12161c",
        success: "#2DD4BF",
        warning: "#FBBF24",
        error: "#F87171",
        info: "#bfdbfe",
      },
    },
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { es },
    current: "es",
  }
});
